<template>
  <button
    :class="[selectedButton?'active':'inactive']"
    class="lf-btn bm-bordered-btn d-flex justify-content-center color-select-btn p-11"
    @click.stop="switchActive">{{ title }}</button>
</template>
<script>
import EventBus from '@/EventBus';

export default {
  name:  'ColorSelectButton',
  props: {
    title:          String,
    id:             { Number, String },
    selectedButton: Boolean,
    type:           String,
  },
  data() {
    return {};
  },

  methods: {
    switchActive() {
      this.$emit('toggleActive', { id: this.id, title: this.title, type: this.type });
    },
  },
};

</script>
<style scoped lang="scss">
  .active {
    &.color-select-btn {
      box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.04), 0px 0px 2px rgba(0, 0, 0, 0.06), 0px 0px 1px rgba(0, 0, 0, 0.04);
      color: $blue50 !important;
      background-color: $white !important;
      border: 1px solid $white !important;
    }
  }
</style>
